import * as React from 'react';
import { connect } from 'react-redux';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { OverviewPage } from '../../../ui';
import { MyHoursSummary, MyHoursList } from './index';
import { MyClaimsList } from '../../my-general-competency-claims/components/index';
import { selectMyHoursOverviewPageTab } from '../actions/my-hours-overview-page-actions';
import { loadMyHoursListPage } from '../actions/my-hours-list-page-actions';

class MyGeneralCompetencyHoursOverviewPage extends React.PureComponent {
  constructor() {
    super();
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  async componentDidMount() {
    await this.props.loadMyHoursListPage();
  }

  render() {
    const localizationService = provideLocalizationService(this);
    const { accessDeniedMessage } = this.props;

    if (accessDeniedMessage) {
      return (
        <OverviewPage
          title={localizationService.toLanguageString('myGeneralCompetencyHours.listTitle')}
          hideBackButton={true}
          warningMessage={accessDeniedMessage}
        />
      );
    }

    return (
      <OverviewPage
        title={localizationService.toLanguageString('myGeneralCompetencyHours.listTitle')}
        hideBackButton={true}
        summary={<MyHoursSummary/>}
        tabs={
          <TabStrip selected={this.props.selectedTab} onSelect={this.handleTabSelect}>
            <TabStripTab title={localizationService.toLanguageString('myGeneralCompetencyHours.tabHours')}/>
            <TabStripTab title={localizationService.toLanguageString('myGeneralCompetencyHours.tabClaims')}/>
          </TabStrip>
        }
      >
        {this.props.selectedTab === 0 && <MyHoursList/>}
        {this.props.selectedTab === 1 && <MyClaimsList/>}
      </OverviewPage>
    );
  }

  handleTabSelect(e) {
    this.props.selectMyHoursOverviewPageTab(e.selected);
  }
}

registerForLocalization(MyGeneralCompetencyHoursOverviewPage);

const mapStateToProps = state => ({
  selectedTab: state.myHoursOverviewPage.selectedTab,
  accessDeniedMessage: state.myGeneralCompetencyHoursListPage.accessDeniedMessage
});

const mapDispatchToProps = dispatch => ({
  selectMyHoursOverviewPageTab: (tabIndex) => dispatch(selectMyHoursOverviewPageTab(tabIndex)),
  loadMyHoursListPage: () => dispatch(loadMyHoursListPage())
});

export default connect(mapStateToProps, mapDispatchToProps)(MyGeneralCompetencyHoursOverviewPage);
